import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import {FiCreditCard, FiShield} from 'react-icons/fi';

const PAYMENT_OPTIONS = [
  {
    label: 'Card',
    description: 'Pay securely online with your credit or debit card.',
    icon: <FiCreditCard />,
  },
];

export default function PaymentMethodSelector({ selectedMethod, onSelect }) {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.headerRow)}>
        <div>
          <p className={css(styles.kicker)}>secure payment</p>
          <h3 className={css(styles.title)}>Choose payment method</h3>
          <p className={css(styles.helper)}>
            Your order is sent to the outlet only after payment is confirmed.
          </p>
        </div>

        <div className={css(styles.securityBadge)}>
          <span><FiShield /></span>
          <strong>Safe</strong>
        </div>
      </div>

      {PAYMENT_OPTIONS.map((method) => {
        const selected = method.label === selectedMethod;

        return (
          <button
            type="button"
            key={method.label}
            className={css(
              styles.optionCard,
              selected && styles.optionSelected,
            )}
            onClick={() => onSelect(method.label)}
          >
            <div
              className={css(styles.iconWrap, selected && styles.iconSelected)}
            >
              {method.icon}
            </div>

            <div className={css(styles.optionContent)}>
              <strong
                className={css(
                  styles.optionTitle,
                  selected && styles.textSelected,
                )}
              >
                {method.label}
              </strong>
              <span
                className={css(
                  styles.optionDescription,
                  selected && styles.descriptionSelected,
                )}
              >
                {method.description}
              </span>
            </div>

            <span
              className={css(styles.radio, selected && styles.radioSelected)}
            >
              {selected ? '✓' : ''}
            </span>
          </button>
        );
      })}
    </div>
  );
}

const styles = StyleSheet.create({
  container: { width: '100%' },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '14px',
    marginBottom: '14px',
    '@media (max-width: 520px)': { flexDirection: 'column' },
  },
  kicker: {
    margin: '0 0 4px',
    color: '#C9A14A',
    fontSize: '11px',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '0.8px',
  },
  title: { margin: 0, color: '#0F3D2E', fontSize: '18px', fontWeight: '900' },
  helper: {
    margin: '6px 0 0',
    color: '#8C8170',
    fontSize: '12px',
    lineHeight: 1.5,
  },
  securityBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#F4EBD8',
    border: '1px solid #E6D8BE',
    color: '#0F3D2E',
    padding: '8px 11px',
    borderRadius: '999px',
    fontSize: '12px',
  },
  optionCard: {
    width: '100%',
    border: '1px solid #E6D8BE',
    backgroundColor: '#ffffff',
    borderRadius: '22px',
    padding: '14px',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    textAlign: 'left',
    cursor: 'pointer',
    boxShadow: '0 8px 22px rgba(30, 30, 30, 0.04)',
  },
  optionSelected: {
    backgroundColor: '#0F3D2E',
    borderColor: '#C9A14A',
    boxShadow: '0 14px 30px rgba(15, 61, 46, 0.14)',
  },
  iconWrap: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    backgroundColor: '#F4EBD8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  iconSelected: { backgroundColor: '#C9A14A' },
  optionContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  optionTitle: { color: '#0F3D2E', fontSize: '15px' },
  optionDescription: { color: '#8C8170', fontSize: '12px', lineHeight: 1.5 },
  textSelected: { color: '#ffffff' },
  descriptionSelected: { color: '#F4EBD8' },
  radio: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: '1px solid #E6D8BE',
    backgroundColor: '#FFFDF7',
    color: '#0F3D2E',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: '900',
    flexShrink: 0,
  },
  radioSelected: { backgroundColor: '#C9A14A', borderColor: '#C9A14A' },
});
